import { ListItemText } from '@global-engineering-shared/gweb-material-ui';
import classNames from 'classnames';

import useStyles from 'components/Table/components/TableItem/components/TableListItem/components/TableListItemColumn/TableListItemColumn.styles';
import { IColumn } from 'components/Table/types/Table';

export const MISSING_ELEMENT_TEXT = 'Missing';

type TableListItemColumnProps = {
  item: any;
  column: IColumn;
  isExpanded: boolean;
};

const TableListItemColumn = ({ item, column, isExpanded }: TableListItemColumnProps) => {
  const classes = useStyles({ isExpanded });
  const key = column.value;
  const itemElement = item[key] ? item[key] : MISSING_ELEMENT_TEXT;
  const color = itemElement === MISSING_ELEMENT_TEXT ? 'error' : 'textPrimary';

  return column.columnContent ? (
    column.columnContent(itemElement, isExpanded)
  ) : (
    <ListItemText
      key={key}
      primaryTypographyProps={{
        variant: 'body2',
        color: color,
      }}
      primary={itemElement}
      className={classNames(classes.itemText, {
        [classes.truncated]: !!column.truncated,
      })}
    />
  );
};

export default TableListItemColumn;
